import {
  getPageHeader,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  PageContainer,
  PageHeader,
  PageHeaderLeading,
} from '@yeshuman/sdk'
import { Users } from 'lucide-react'

export function PatientsPage() {
  const { title, description } = getPageHeader('/patients', 'Patients', 'Manage your patient roster and access patient information.')
  return (
    <PageContainer>
      <PageHeader leading={<PageHeaderLeading />} title={title} description={description} icon={<Users className="h-5 w-5" />} />
      <Card>
        <CardHeader>
          <CardTitle>Patient management</CardTitle>
          <CardDescription>
            Coming soon - View patient lists, access health records, and manage care teams.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <Users className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
            <p className="text-lg font-medium mb-2">Patient Management</p>
            <p className="text-sm text-muted-foreground">
              Coming soon - View patient lists, access health records, and manage care teams.
            </p>
          </div>
        </CardContent>
      </Card>
    </PageContainer>
  )
}

